import Vue from 'vue';
import Router from 'vue-router';
import { getStorage } from '@/plugins/utils';
Vue.use(Router);
import store from '@/store';
const routes = [
	{
		path: "/",
		name: "Download",
		meta: {
			auth: false
		},
		component: () => import("@/views/index/download"),
	},{
		path: "/login",
		name: "Login",
		meta: {
			auth: false
		},
		component: () => import("@/views/login/login"),
	},{
		path: "/register",
		name: "Register",
		meta: {
			auth: false
		},
		component: () => import("@/views/login/register"),
	},
	{
		path: "/user",
		name: "Common",
		component: () => import("@/views/common.vue"),
		children: [
			{
				path: "/user/index",
				name: "Index",
				meta: {
					auth: true
				},
				component: () => import("@/views/index/index"),
			},{
				path: "/user/info",
				name: "Info",
				meta: {
					auth: true
				},
				component: () => import("@/views/user/info"),
			},{
				path: "/user/info",
				name: "Info",
				meta: {
					auth: true
				},
				component: () => import("@/views/user/info"),
			},{
				path: "/user/share",
				name: "Share",
				meta: {
					auth: true
				},
				component: () => import("@/views/user/share"),
			},{
				path: "/user/hj",
				name: "Hj",
				meta: {
					auth: true
				},
				component: () => import("@/views/user/hj"),
			},{
				path: "/user/qc",
				name: "Qc",
				meta: {
					auth: true
				},
				component: () => import("@/views/user/qc"),
			},{
				path: "/user/record",
				name: "Record",
				meta: {
					auth: true
				},
				component: () => import("@/views/user/record"),
			},{
				path: "/user/vip",
				name: "Vip",
				meta: {
					auth: true
				},
				component: () => import("@/views/user/vip"),
			},{
				path: "/user/qsy",
				name: "Qsy",
				meta: {
					auth: true
				},
				component: () => import("@/views/user/qsy"),
			}
		]
	}
];
const router = new Router({
	mode: "hash", //hash  history
	base: '/',  // 如果使用history模式，必须设置base参数
	routes
});
// 路由守卫
router.beforeEach((to, from, next) => {
	// 让页面回到顶部
	document.documentElement.scrollTop = 0;
	if (to.meta.auth) {
		if (store.state.userInfo.token) {
			next();
		} else {
			let userInfo = getStorage("userInfo");
			if (userInfo && userInfo.token) {
				next();
			} else {
				next('/login');
				// store.commit("setShowLogin", true);
			}
		}
	} else {
		next();
	}
});
export default router;
